// DEPRECATED
// This module conflicts with the internal node constants module and can't be
// used in jest tests - see https://github.com/facebook/jest/issues/1641.
// Please use learn-constants instead.
import * as constants from '@get-bridge/learn-legacy-shared/dist/shared/learn-constants';
export default constants;



// WEBPACK FOOTER //
// ./jsapp/shared/constants.js